<template>
  <div>
    <div v-if="!loadStatus">
      <Skeleton width="100%" height="3.5rem" v-for="i in 15" :key="i" />
    </div>
    <template v-if="loadStatus">
      <div class="button-wrapper">
        <button
          class="button-gemnote button-gemnote--small"
          @click="showAddNewTeamModal"
        >
          <span>Add Team</span>
        </button>
      </div>
      <AddTeamModal :showFooter="false" v-if="showModal" colorVariation="coast">
        <template slot="header">
          <h4 class="header">Add Team</h4>
        </template>
        <template slot="body">
          <AddTeamForm />
        </template>
      </AddTeamModal>
      <TeamList :teamList="teamsList" />
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { progressStatus } from '../../helpers'

export default {
  name: 'ManageTeams',
  data() {
    return {
      teamName: ''
    }
  },
  created() {
    this.$store.dispatch('subTeams/getTeamsList')
  },
  components: {
    AddTeamModal: () => import('@/components/Universal/Modal'),
    AddTeamForm: () => import('@/components/Subteams/AddTeamForm'),
    TeamList: () => import('@/components/Subteams/TeamList'),
    Skeleton: () => import('@/components/Universal/Skeleton')
  },
  computed: {
    loadStatus() {
      return progressStatus(this.loadTeamsList)
    },
    ...mapState({
      showModal: state => state.modal.showModal,
      loadTeamsList: state => state.subTeams.loadTeamsList,
      teamsList: state => state.subTeams.teamsList
    })
  },
  methods: {
    showAddNewTeamModal() {
      this.$store.dispatch('modal/showModal')
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/global.scss';

h4 {
  font-size: 2rem;
  font-weight: normal;
  color: $main-white;
  font-family: $editorial;
}
.header {
  color: $pebble;
}
.button-wrapper {
  display: flex;
  justify-content: left;

  .button-gemnote {
    font-size: 0.813rem;
    height: 2.5rem;
    width: auto;
    padding: 0 1.5rem;
  }
}
</style>
